import React, { useCallback } from 'react';
import cx from 'classnames';
import {
    Box,
    Button,
    Divider,
    makeStyles,
    Typography,
    useMediaQuery,
    useTheme,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Hidden } from '€components/Hidden';
import { logout } from '€slices/auth';

const useStyles = makeStyles(theme => ({
    buttonContainer: {
        borderLeft: `3px solid transparent`,
    },
    button: {
        display: 'block',
        textAlign: 'left',
        padding: 0,
        height: 'auto',
        '& > span': {
            marginTop: 0,
        },
        '&:hover': {
            color: `${theme.palette.primary.main}`,
            backgroundColor: 'transparent',
        },
    },
    withChevron: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));

const LogoutOption: React.FunctionComponent = () => {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch();
    const history = useHistory();

    const signOut = useCallback(async () => {
        try {
            await dispatch(logout());
            history.replace('/');
            // eslint-disable-next-line no-empty
        } catch (e) {}
    }, [dispatch, history]);

    return (
        <Box>
            <Box
                className={cx(classes.buttonContainer, { [classes.withChevron]: !matches })}
                pl={{ xs: 0, sm: 3 }}
                py={1.5}
            >
                <Button className={classes.button} variant="text" onClick={signOut}>
                    <Typography variant="subtitle1">Log out</Typography>
                </Button>
                <Hidden smUp>
                    <ChevronRightIcon color="secondary" />
                </Hidden>
            </Box>
            <Hidden smUp>
                <Divider />
            </Hidden>
        </Box>
    );
};

export default LogoutOption;
